import React from 'react';

const packages = [
  
  {
    id: 3,
    image: '/images/gallery/5.jpg',
    price: '$2,000',
    duration: '6D/5N',
    people: 6,
    location: 'Pune',
    title: 'Innova Crysta',
    description: 'Experience Portugal’s rich culture and history with the Innova Cab package. A 6-day trip perfect for medium-sized groups, offering guided tours and unique local experiences.'
  },
  {
    id: 1,
    image: '/images/gallery/4.jpg',
    price: '$1,900',
    duration: '7D/6N',
    people: 5,
    location: 'Pune',
    title: 'Ertiga',
    description: 'Enjoy 7 days of comfort and adventure, blending city vibes and natural beauty with smooth rides, spacious interiors, and reliable service. Perfect for groups up to 7 people.'
  },
  {
    id: 2,
    image: '/images/gallery/9.jpg',
    price: '$1,230',
    duration: '5D/4N',
    people: 8,
    location: 'Pune',
    title: 'Tempo Traveller',
    description: 'Discover the diverse beauty of India with the Tempo Traveller package. This 5-day tour is designed for larger groups, combining exciting city tours with relaxing countryside escapes.'
  },
  
];


const PackageSection = () => {
  return (
    <section className="package-section">
      <div className="container">
        {/* Section Heading */}
        <div className="section-heading text-center">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <h5 className="dash-style">EXPLORE POPULAR CAR</h5>
              <h2>POPULAR CAR</h2>
            
            </div>
          </div>
        </div>

        {/* Package Items */}
        <div className="package-inner">
          <div className="row">
            {packages.map((pkg) => (
              <div className="col-lg-4 col-md-6" key={pkg.id}>
                <div className="package-wrap">
                  <figure className="feature-image borderr">
                    <a href="#">
                      <img src={pkg.image} alt={pkg.title} />
                    </a>
                  </figure>
                  
                  <div className="package-content-wrap">
                    <div className="package-meta text-center">
                      <ul>
                        <li><i className="fas fa-user-friends"></i> People: {pkg.people}</li>
                        <li><i className="fas fa-map-marker-alt"></i> {pkg.location}</li>
                      </ul>
                    </div>
                    <div className="package-content">
                      <h3 className='text-center'><a href="#" className='colorred'>{pkg.title}</a></h3>
                    
                      <p>{pkg.description}</p>
                      <div className=" text-center">
                        <a href="/booking" className="button-text btn-wrapp width-6 rounded-5">Book Now <i className="fas fa-arrow-right"></i></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          
        </div>
      </div>
    </section>
  );
};

export default PackageSection;
